'use strict';

var implementation = require('./implementation');

module.exports = Function.prototype.bind || implementation;



//////////////////
// WEBPACK FOOTER
// ./node_modules/function-bind/index.js
// module id = ./node_modules/function-bind/index.js
// module chunks = main